var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('system-bar'),_c('lab-menu')],1),_c('div',[_c('v-card',[_c('v-card-text',[_c('signup-form',{attrs:{"labId":_vm.labId},on:{"signupSuccess":_vm.saveSuccess}})],1)],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }